import { render, staticRenderFns } from "./CalculateTwists.vue?vue&type=template&id=69596de0&"
import script from "./CalculateTwists.vue?vue&type=script&lang=js&"
export * from "./CalculateTwists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports